module.exports = __webpack_public_path__ + "static/media/ic-arrow-up-green.7dca76f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-up-green.svg
// module id = 597
// module chunks = 14